
export default
  {
    removeFromArrayByKey(array, key, value) {
      
      if(!array)
        return;

      for (var i = 0; i < array.length; i++) {
        if (array[i][key] == value) {
          array.splice(i, 1);
          if(!array)
            array = [];
          return array;
        }
      }

      return array;
    },

    removeFromArrayByIndex(array, index) {
      if(!array)
        return;

      array.splice(index, 1);
      if(!array)
        array = [];
      return array;
    },

    replaceInArray(array, key, object) {
      if(!array)
        return;

      for (var i = 0; i < array.length; i++) {
        if (array[i][key] == object[key]) {
          array[i] = object;
          return array;
        }
      }
    },

    insertInArray(array, index, object) {
      if(!array)
        return;

      array.splice(index, 0, object);
      return array;
    },

    copyObject(object) {
      var objectStr = JSON.stringify(object);
      var copy = JSON.parse(objectStr);
      return copy;
    },

    copyArray(array) {
      if(!array)
        return;
        
      var copy = array.slice(0);
      return copy;
    },

    urlCombine(base, path) {
      if (base.substring(base.length - 1) != "/") {
        base += "/";
      }
      return base + path;
    },

    sortByKey(array, key) {
      return array.sort(function (a, b) {
          var x = a[key]; var y = b[key];
          if(x == null && y != null) return 1;
          if(y == null && x != null) return -1;
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    },

    expandJSON(json, priorKey, priorSub) {
      let result = {};
      if(!priorSub)
        priorSub = "$[";
      for(let key in json) {
          let value = json[key];
          let sub = priorSub;

          // append key to sub (before braces and dot are added)
          if(sub != "$[")
              sub += ",";
          sub += key;

          // close sub
          let closedSub = sub + "]";

          // format key w/ brace or dot
          if(Array.isArray(json)) {
            key = "[" + json.indexOf(value) + "]";
          }
          else if(typeof(json) == "object" && priorKey) {
            key = "." + key;
          }

          // append key to prior key
          let expandedKey = key;
          if(priorKey)
              expandedKey = priorKey + key;
          
          result[expandedKey] = {value: value, sub: closedSub};

          if(typeof(value) == "object") {
            var inner = this.expandJSON(value, expandedKey, sub);
            for(let innerKey in inner) {
              let innerValue = inner[innerKey].value;
              let innerSub = inner[innerKey].sub;
              result[innerKey] = {value: innerValue, sub: innerSub};
            }
          }          
       }
      return result;
    },

    getInputFields(store, workflow) {
      var allFields = {};
      var types = store.getters["nodeStore/getInputTypes"];
      for (var i = 0; i < types.length; i++) {
        var type = types[i];

        if(!type.plural)
          continue;

        for (var j = 0; j < workflow[type.plural].length; j++) {
          var input = workflow[type.plural][j];
          var fields = [];

          // vars
          if(input.vars) {
            for (var k = 0; k < input.vars.length; k++) {
              var field = input.vars[k];
              fields.push({ object: input.shortname, field: field.name });
            }
          }

          // fields
          if(input.fields) {
            for (var k = 0; k < input.fields.length; k++) {
              var field = input.fields[k];
              fields.push({ object: input.shortname, field: field });
            }
          }

          // config.fields (geoInputs)
          if(input.config && input.config.fields) {
            for (var k = 0; k < input.config.fields.length; k++) {
              var field = input.config.fields[k];
              fields.push({ object: input.shortname, field: field });
            }
          }

          // geometry field
          if(input.includeGeometry) {
            fields.push({ object: input.shortname, field:  "GEOMETRY" });
            fields.push({ object: input.shortname, field:  "GEOMETRY.SPATIALREFERENCE" });
            if(input.geometryType == "esriGeometryPoint") {
              fields.push({ object: input.shortname, field:  "GEOMETRY.X" });
              fields.push({ object: input.shortname, field:  "GEOMETRY.Y" });
            }
          }
          
          if(fields.length > 0)
            allFields[input.shortname] = fields;
        }
      }
      return allFields;
    },

    getOutputFields(store, workflow) {
      var allFields = {};

      var types = store.getters["nodeStore/getOutputTypes"];
      for (var i = 0; i < types.length; i++) {
        var type = types[i];

        for (var j = 0; j < workflow[type.plural].length; j++) {
          var output = workflow[type.plural][j];
          var fields = [];

          // vars
          if(output.vars) {
            for (var k = 0; k < output.vars.length; k++) {
              var field = output.vars[k];
              fields.push({object: output.shortname, field: field.name });
            }
          }

          // fields
          if(output.fields) {
            for (var k = 0; k < output.fields.length; k++) {
              var field = output.fields[k];
              fields.push({object: output.shortname, field: field });
            }
          }
          
          // child fields
          if(output.childObjects) {
            for (var k = 0; k < output.childObjects.length; k++) {
              var child = output.childObjects[k];
              for (var l = 0; l < child.fields.length; l++) {
                var field = child.fields[l];
                fields.push({
                  object: output.shortname,
                  field: field,
                  alias: !!child.value ? child.value : "",
                  child: { shortname: child.shortname, name: child.name }
                });       
              }
            }
          }
          
          // geometry
          if(output.includeGeometry) {
            fields.push({ 
              object: output.shortname, 
              field: "GEOMETRY" 
            });
          }

          if(fields.length > 0)
            if(_.get(output,'name') !== undefined){
              allFields[output.shortname+" "+output.name] = fields;
            }else{
              allFields[output.shortname] = fields;
            }
          }
      }
      return allFields;
    },

    fieldsToOptionGroups(fields) {
      var groups = {};
      var objects = Object.keys(fields);
      for(var i = 0; i < objects.length; i++) {
        var object = objects[i];
        var objectFields = fields[object];
        var options = [];
        for(var j = 0; j < objectFields.length; j++) {
          var field = objectFields[j];
          var option = {value: field};
          if(field.child){
            let alias = field.alias != "" ? " " + field.alias : "";
            option.text = field.object + ", " + field.child.shortname + ": " + field.child.name + "." + field.field + alias;
            delete option.value.alias
          }
          else 
          option.text = field.object + ": " + field.field;
          options.push(option);
        }
        groups[object] = options;
      }
      return groups;
    }

  }



// WEBPACK FOOTER //
// ./src/util/util.js